module.exports = __webpack_public_path__ + "img/hero.38e0bfd1.png";